import { create } from 'zustand'

// The module strip owns the readiness sync — it holds the page's one
// useReadiness() and the sync-summary modal — but shows no button for it. It
// publishes the action here so the user menu can offer `Sync now`.

interface SyncActionState {
  syncNow: (() => Promise<void>) | null // null while no strip is mounted
  syncing: boolean
  setAction: (syncNow: (() => Promise<void>) | null) => void
  setSyncing: (syncing: boolean) => void
}

export const useSyncActionStore = create<SyncActionState>()((set) => ({
  syncNow: null,
  syncing: false,
  setAction: (syncNow) => set({ syncNow }),
  setSyncing: (syncing) => set({ syncing }),
}))
